export default {
    navigationBarTitleText: "选择参与人",
  };
  